export default {"src":"/_next/static/media/guidance.colour.77376d33.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};